import { Chip } from '@mui/material';

import type { SerialValidationStatus } from '@/domain/izzi';

interface StatusChipProps {
  status: SerialValidationStatus;
}

const LABELS: Record<SerialValidationStatus, string> = {
  OK: 'OK',
  QUARANTINED: 'Cuarentena',
  REJECTED: 'Rechazada',
  ERROR: 'Error',
};

const COLORS: Record<SerialValidationStatus, 'success' | 'warning' | 'error' | 'default'> = {
  OK: 'success',
  QUARANTINED: 'warning',
  REJECTED: 'error',
  ERROR: 'default',
};

export default function StatusChip({ status }: StatusChipProps) {
  return <Chip label={LABELS[status]} color={COLORS[status]} size="small" variant="outlined" />;
}
